import "./App.css";

import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import AuthApolloProvider from "./auth/authApolloProvider";
import { BrowserRouter } from "react-router-dom";
import { ContextManager } from "./context/ContextManager";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { Provider } from "react-redux";
import React from "react";
import { Routing } from "./navigation/Routing";
import { ThemeProvider } from "@mui/material";
import { defaultTheme } from "../src/styles/muiTheme";
import store from "./state/store";
import SnackbarWrapper from "./components/Wrapper/SnackbarWrapper";

function App() {
  return (
    <>
      <BrowserRouter>
        <Provider store={store}>
          <ThemeProvider theme={defaultTheme}>
            <AuthApolloProvider>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <ContextManager>
                  <Routing />
                  <SnackbarWrapper />
                </ContextManager>
              </LocalizationProvider>
            </AuthApolloProvider>
          </ThemeProvider>
        </Provider>
      </BrowserRouter >
    </>
  );
}

export default App;
